// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { EventSource } from '@shared/utils/Event/EventConstants.types';
export class TicketEntry {
    constructor(caption, text) {
        this.caption = '';
        this.text = '';
        this.caption = caption;
        this.text = text;
    }
}
export class TicketData {
    constructor() {
        this.screenHeader = '';
        this.text = '';
        this.header = '';
        this.sortedEntries = new Array();
        this.isTrade = false;
        this.eventSource = EventSource.None;
        this.soundKey = '';
    }
}
